import React, { createContext, useContext } from 'react'
import { AdvisorData, Certification, RoboAdvisorData } from '../../../utils/types'
import { TypeLabels, CtaLabels, FeeStructureTooltips } from './advisorUtils'

interface AdvisorCardContextValue {
  advisorData: AdvisorData | RoboAdvisorData
  certifications: Certification[]
  typeLabels: TypeLabels
  feeStructureTooltips: FeeStructureTooltips
  ctaLabels: CtaLabels
  position: number
}

const AdvisorCardContext = createContext<AdvisorCardContextValue | null>(null)

export const AdvisorCardProvider = ({ children, ...value }: AdvisorCardContextValue & { children: React.ReactNode }) => (
  <AdvisorCardContext.Provider value={value}>
    {children}
  </AdvisorCardContext.Provider>
)

export const useAdvisorCard = (): AdvisorCardContextValue => {
  const ctx = useContext(AdvisorCardContext)
  if (!ctx) throw new Error('useAdvisorCard must be used within AdvisorCardProvider')
  return ctx
}
